import React from 'react'
import closeSVG from './Icons/close.svg'
import sadHumiSVG from './Icons/sad-humi.svg'
import happyHumiSVG from './Icons/happy-humi.svg'

export const close = closeSVG
export const happyHumi = happyHumiSVG
export const sadHumi = sadHumiSVG
export const penToSquare = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5625 12.7812L14.5625 11.7812C14.6458 11.6979 14.7396 11.6771 14.8438 11.7188C14.9479 11.7604 15 11.8438 15 11.9688V16.5C15 16.9167 14.8542 17.2708 14.5625 17.5625C14.2708 17.8542 13.9167 18 13.5 18H2.5C2.08333 18 1.72917 17.8542 1.4375 17.5625C1.14583 17.2708 1 16.9167 1 16.5V5.5C1 5.08333 1.14583 4.72917 1.4375 4.4375C1.72917 4.14583 2.08333 4 2.5 4H11.0625C11.1667 4 11.2396 4.05208 11.2812 4.15625C11.3229 4.26042 11.3021 4.35417 11.2188 4.4375L10.2188 5.4375C10.1771 5.47917 10.125 5.5 10.0625 5.5H2.5V16.5H13.5V12.9375C13.5 12.875 13.5208 12.8229 13.5625 12.7812ZM18.4688 6.46875L10.25 14.6875L7.4375 15C7.02083 15.0417 6.66667 14.9167 6.375 14.625C6.08333 14.3333 5.95833 13.9792 6 13.5625L6.3125 10.75L14.5312 2.53125C14.8854 2.17708 15.3177 2 15.8281 2C16.3385 2 16.7708 2.17708 17.125 2.53125L18.4688 3.875C18.8229 4.22917 19 4.66146 19 5.17188C19 5.68229 18.8229 6.11458 18.4688 6.46875ZM15.375 7.4375L13.5625 5.625L7.75 11.4375L7.53125 13.4688L9.5625 13.25L15.375 7.4375ZM17.4062 4.9375L16.0625 3.59375C16 3.53125 15.9219 3.5 15.8281 3.5C15.7344 3.5 15.6562 3.53125 15.5938 3.59375L14.625 4.5625L16.4375 6.375L17.4062 5.40625C17.4688 5.34375 17.5 5.26562 17.5 5.17188C17.5 5.07812 17.4688 5 17.4062 4.9375Z'
      fill='#313D98'
    />
  </svg>
)

export const drawSignature = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.8958 19.0314C14.8958 18.4917 15.114 17.9748 15.5008 17.5983L21.7023 11.5616L24.425 14.2118L18.2008 20.2705C17.8274 20.634 17.3268 20.8374 16.8057 20.8374H14.8958V20.8081C14.6992 20.8739 14.5219 20.9288 14.3745 20.9635C13.6109 21.2037 12.8037 21.283 12.0065 21.1959C11.4644 21.1342 10.9767 20.8465 10.6696 20.4077C10.3565 19.8284 10.315 19.1459 10.5559 18.535C9.13533 19.2721 6.21769 21.1479 5.11756 21.883C4.93474 22.0019 4.7058 22.0327 4.49655 21.9663C4.28746 21.8999 4.12114 21.7436 4.04547 21.5426C3.96981 21.3416 3.99321 21.1177 4.10881 20.9356L4.10863 20.9356L7.28754 16.0475C7.39784 15.8695 7.38038 15.6432 7.24407 15.4832C7.10795 15.3232 6.88258 15.2644 6.68247 15.3371L5.25423 15.9088C5.07007 15.9786 4.86233 15.8925 4.78615 15.7149L4.51629 15.0706C4.44476 14.8912 4.53319 14.689 4.7157 14.615L4.71573 14.6148L6.07578 14.047C6.58305 13.8253 7.16394 13.8271 7.6697 14.052C8.17563 14.2769 8.55723 14.7032 8.71696 15.2217C8.87687 15.7401 8.79929 16.3006 8.50418 16.7594L7.16696 18.8229C9.89175 17.0762 10.8545 16.7368 11.4031 16.8034C12.6152 16.9519 12.0903 18.4356 12.0309 18.5998C11.7814 19.3469 11.7918 19.7038 12.2909 19.7941C12.8911 19.8309 13.4926 19.7543 14.0627 19.5685C14.2882 19.515 14.5748 19.4236 14.8958 19.3191V19.0314ZM26.4302 9.53826C27.1962 10.2838 27.1962 11.5143 26.4302 12.2599L25.7863 12.8867L23.0637 10.2365L23.781 9.53826C24.5183 8.82058 25.693 8.82058 26.4302 9.53826Z'
        fill='black'
      />
    </svg>
  )
}

export const typeSignature = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.5 26C3.56704 26 2 24.278 2 22.1539V9.84612C2 7.72198 3.56704 6 5.5 6H26.5C28.4331 6 30 7.72198 30 9.84612V22.1539C30 24.278 28.4331 26 26.5 26H5.5ZM4.1 22.1539V9.84612C4.1 8.99646 4.72688 8.30772 5.5 8.30772H26.5C27.2731 8.30772 27.9 8.99646 27.9 9.84612V22.1539C27.9 23.0034 27.2731 23.6923 26.5 23.6923H5.5C4.72688 23.6923 4.1 23.0034 4.1 22.1539ZM5.11111 11.5556C5.11111 10.9419 5.52903 10.4444 6.04444 10.4444H7.28889C7.8043 10.4444 8.22222 10.9419 8.22222 11.5556C8.22222 12.1692 7.8043 12.6667 7.28889 12.6667H6.04444C5.52903 12.6667 5.11111 12.1692 5.11111 11.5556ZM5.11111 20.4444C5.11111 19.8308 5.52903 19.3333 6.04444 19.3333H7.28889C7.8043 19.3333 8.22222 19.8308 8.22222 20.4444C8.22222 21.0581 7.8043 21.5556 7.28889 21.5556H6.04444C5.52903 21.5556 5.11111 21.0581 5.11111 20.4444ZM10.3236 19.3333C9.73583 19.3333 9.25926 19.8308 9.25926 20.4444C9.25926 21.0581 9.73583 21.5556 10.3236 21.5556H21.6764C22.2643 21.5556 22.7407 21.0581 22.7407 20.4444C22.7407 19.8308 22.2643 19.3333 21.6764 19.3333H10.3236ZM9.25926 11.5556C9.25926 10.9419 9.67718 10.4444 10.1926 10.4444H11.437C11.9525 10.4444 12.3704 10.9419 12.3704 11.5556C12.3704 12.1692 11.9525 12.6667 11.437 12.6667H10.1926C9.67718 12.6667 9.25926 12.1692 9.25926 11.5556ZM13.4074 11.5556C13.4074 10.9419 13.8252 10.4444 14.3407 10.4444H15.5852C16.1007 10.4444 16.5185 10.9419 16.5185 11.5556C16.5185 12.1692 16.1007 12.6667 15.5852 12.6667H14.3407C13.8252 12.6667 13.4074 12.1692 13.4074 11.5556ZM17.5556 11.5556C17.5556 10.9419 17.9733 10.4444 18.4889 10.4444H19.7333C20.2489 10.4444 20.6667 10.9419 20.6667 11.5556C20.6667 12.1692 20.2489 12.6667 19.7333 12.6667H18.4889C17.9733 12.6667 17.5556 12.1692 17.5556 11.5556ZM12.3704 14.8889C11.7977 14.8889 11.3333 15.3863 11.3333 16C11.3333 16.6137 11.7977 17.1111 12.3704 17.1111H14.4444C15.0173 17.1111 15.4815 16.6137 15.4815 16C15.4815 15.3863 15.0173 14.8889 14.4444 14.8889H12.3704ZM17.5556 14.8889C16.9827 14.8889 16.5185 15.3863 16.5185 16C16.5185 16.6137 16.9827 17.1111 17.5556 17.1111H19.6296C20.2025 17.1111 20.6667 16.6137 20.6667 16C20.6667 15.3863 20.2025 14.8889 19.6296 14.8889H17.5556ZM24.7111 19.3333C24.1956 19.3333 23.7778 19.8308 23.7778 20.4444C23.7778 21.0581 24.1956 21.5556 24.7111 21.5556H25.9556C26.4711 21.5556 26.8889 21.0581 26.8889 20.4444C26.8889 19.8308 26.4711 19.3333 25.9556 19.3333H24.7111ZM22.6759 14.8889C22.1389 14.8889 21.7037 15.3863 21.7037 16C21.7037 16.6137 22.1389 17.1111 22.6759 17.1111H25.9167C26.4537 17.1111 26.8889 16.6137 26.8889 16C26.8889 15.3863 26.4537 14.8889 25.9167 14.8889H22.6759ZM6.08333 14.8889C5.54644 14.8889 5.11111 15.3863 5.11111 16C5.11111 16.6137 5.54644 17.1111 6.08333 17.1111H9.32407C9.86096 17.1111 10.2963 16.6137 10.2963 16C10.2963 15.3863 9.86096 14.8889 9.32407 14.8889H6.08333ZM23.7778 10.4444C23.2049 10.4444 22.7407 10.9419 22.7407 11.5556C22.7407 12.1692 23.2049 12.6667 23.7778 12.6667H25.8519C26.4247 12.6667 26.8889 12.1692 26.8889 11.5556C26.8889 10.9419 26.4247 10.4444 25.8519 10.4444H23.7778Z'
        fill='black'
      />
    </svg>
  )
}

export const photoSignature = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.796 7.44444L19.6 5H12.4L10.204 7.44444H6.4L6.24281 7.44967C4.99533 7.53284 4 8.59822 4 9.88889V24.5556L4.00513 24.7157C4.08678 25.9862 5.1328 27 6.4 27H25.6L25.7572 26.9948C27.0047 26.9116 28 25.8462 28 24.5556V9.88889L27.9949 9.72878C27.9132 8.4582 26.8672 7.44444 25.6 7.44444H21.796ZM13.2916 6.99925H18.7076L20.9042 9.44444H25.6L25.6683 9.45152C25.8476 9.48873 26 9.66844 26 9.88889V24.5556L25.9931 24.6361C25.957 24.8448 25.7841 25 25.6 25H6.4L6.33173 24.9929C6.15239 24.9557 6 24.776 6 24.5556V9.88889L6.0069 9.80833C6.04304 9.59966 6.21588 9.44444 6.4 9.44444H11.0958L13.2916 6.99925ZM16 11.5083C19.3137 11.5083 22 14.1945 22 17.5083C22 20.822 19.3137 23.5083 16 23.5083C12.6863 23.5083 10 20.822 10 17.5083C10 14.1945 12.6863 11.5083 16 11.5083ZM16 13.8136C13.9595 13.8136 12.3054 15.4678 12.3054 17.5083C12.3054 19.5487 13.9595 21.2029 16 21.2029C18.0405 21.2029 19.6946 19.5487 19.6946 17.5083C19.6946 15.4678 18.0405 13.8136 16 13.8136ZM8 12.5083C8.55228 12.5083 9 12.0605 9 11.5083C9 10.956 8.55228 10.5083 8 10.5083C7.44772 10.5083 7 10.956 7 11.5083C7 12.0605 7.44772 12.5083 8 12.5083Z'
        fill='black'
      />
    </svg>
  )
}

export const gem = () => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 140 140'>
    <defs>
      <linearGradient id='linear-gradient' y1='70' x2='140' y2='70' gradientUnits='userSpaceOnUse'>
        <stop offset='0.05' stopColor='#fbde64' />
        <stop offset='0.34' stopColor='#fbdb54' />
        <stop offset='0.89' stopColor='#f9d22a' />
        <stop offset='1' stopColor='#f9d021' />
      </linearGradient>
      <linearGradient id='linear-gradient-2' x1='13.4' y1='49.26' x2='13.4' y2='92.54' gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#89c4f6' />
        <stop offset='0.42' stopColor='#b6daf9' />
        <stop offset='0.9' stopColor='#eef6fc' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-3'
        x1='26.05'
        y1='12.33'
        x2='26.05'
        y2='47.64'
        xlinkHref='#linear-gradient-2'
      />
      <linearGradient id='linear-gradient-4' y1='113.95' x2='52.11' y2='113.95' gradientUnits='userSpaceOnUse'>
        <stop offset='0.46' stopColor='#59acf2' />
        <stop offset='0.59' stopColor='#4b9ee4' />
        <stop offset='0.84' stopColor='#277ac0' />
        <stop offset='1' stopColor='#0d60a6' />
      </linearGradient>
      <linearGradient
        id='linear-gradient-5'
        x1='48.78'
        y1='126.6'
        x2='98.19'
        y2='126.6'
        xlinkHref='#linear-gradient-4'
      />
      <linearGradient
        id='linear-gradient-6'
        x1='92.53'
        y1='113.95'
        x2='126.58'
        y2='113.95'
        gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#a8dcd5' />
        <stop offset='0.13' stopColor='#9bd7cf' />
        <stop offset='0.36' stopColor='#79c9be' />
        <stop offset='0.67' stopColor='#42b2a3' />
        <stop offset='1' stopColor='#009782' />
      </linearGradient>
      <linearGradient id='linear-gradient-7' x1='126.6' y1='89.16' x2='126.6' y2='58.39' gradientUnits='userSpaceOnUse'>
        <stop offset='0' stopColor='#a8dcd5' />
        <stop offset='1' stopColor='#009782' />
      </linearGradient>
      <linearGradient id='linear-gradient-8' x1='113.95' y1='42.17' x2='113.95' y2='3.9' gradientUnits='userSpaceOnUse'>
        <stop offset='0.08' stopColor='#a8dcd5' />
        <stop offset='1' stopColor='#e6f5f3' />
      </linearGradient>
      <linearGradient id='linear-gradient-9' x1='90.68' y1='13.4' x2='45.36' y2='13.4' xlinkHref='#linear-gradient-8' />
    </defs>
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <polygon className='cls-1' points='41.01 140 0 99 0 41 41.01 0 99 0 140 41 140 99 99 140 41.01 140' />
        <polygon
          className='cls-2'
          points='87.89 26.8 52.11 26.8 26.8 52.11 26.8 87.89 52.11 113.2 87.89 113.2 113.2 87.89 113.2 52.11 87.89 26.8'
        />
        <polygon className='cls-3' points='26.8 52.11 26.8 87.89 0 99 0 41 26.8 52.11' />
        <polygon className='cls-4' points='26.8 52.11 52.11 26.8 41.01 0 0 41 26.8 52.11' />
        <polygon className='cls-5' points='26.8 87.89 0 99 41.01 140 52.11 113.2 26.8 87.89' />
        <polygon className='cls-6' points='52.11 113.2 41.01 140 99 140 87.89 113.2 52.11 113.2' />
        <polygon className='cls-7' points='87.89 113.2 99 140 140 99 113.2 87.89 87.89 113.2' />
        <polygon className='cls-8' points='113.2 87.89 113.2 52.11 140 41 140 99 113.2 87.89' />
        <polygon className='cls-9' points='140 41 113.2 52.11 87.89 26.8 99 0 140 41' />
        <polygon className='cls-10' points='41.01 0 52.11 26.8 87.89 26.8 99 0 41.01 0' />
      </g>
    </g>
  </svg>
)
export const supriseBox = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='44' height='43' viewBox='0 0 44 43'>
    <defs>
      <radialGradient
        id='23sr62kz0c'
        cx='50%'
        cy='0%'
        r='200.01%'
        fx='50%'
        fy='0%'
        gradientTransform='matrix(0 .49997 -1 0 .5 -.25)'>
        <stop offset='.041%' stopColor='#F8C26D' />
        <stop offset='100%' stopColor='#E48A21' />
      </radialGradient>
      <radialGradient
        id='19rv1hpfyd'
        cx='50%'
        cy='0%'
        r='185.714%'
        fx='50%'
        fy='0%'
        gradientTransform='matrix(0 .53846 -1 0 .5 -.27)'>
        <stop offset='.041%' stopColor='#F8C26D' />
        <stop offset='100%' stopColor='#E48A21' />
      </radialGradient>
      <linearGradient id='hf4iznxmua' x1='50%' x2='50%' y1='0%' y2='100%'>
        <stop offset='0%' stopColor='#FFD166' />
        <stop offset='100%' stopColor='#FFEA9F' />
      </linearGradient>
      <linearGradient id='ojvt1t8gib' x1='50%' x2='50%' y1='0%' y2='100%'>
        <stop offset='0%' stopColor='#FFD166' />
        <stop offset='100%' stopColor='#FFEA9F' />
      </linearGradient>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g>
            <g
              fill='url(#hf4iznxmua)'
              fillRule='nonzero'
              transform='translate(-916 -3952) translate(916 3955) translate(4) translate(1.36 17.09)'>
              <g>
                <path d='M0 0h31.28v19.065c0 1.02-.83 1.845-1.855 1.845H1.855C.83 20.91 0 20.084 0 19.065V0z' />
              </g>
            </g>
            <path
              stroke='#3DB988'
              strokeWidth='5'
              d='M5.948 1.163C7.439.153 9.159-.183 10.759.093c1.608.277 3.09 1.173 4.08 2.606.162.235.308.48.436.734h0l1.222 2.414 1.461-2.278c1.124-1.75 2.737-2.887 4.49-3.335 1.744-.447 3.618-.208 5.244.765 1.029.713 1.58 1.637 1.58 2.663 0 .82-.326 1.563-.857 2.11-.528.542-1.257.89-2.068.921h0l-18.533.003c-.854 0-1.628-.345-2.188-.902-.56-.557-.906-1.326-.906-2.176 0-.967.457-1.875 1.228-2.455z'
              transform='translate(-916 -3952) translate(916 3955) translate(4)'
            />
            <path
              fill='#D1873F'
              fillRule='nonzero'
              stroke='#D1873F'
              strokeWidth='3'
              d='M2.287 17.951H31.712V18.951H2.287z'
              transform='translate(-916 -3952) translate(916 3955) translate(4)'
            />
            <path
              fill='url(#ojvt1t8gib)'
              fillRule='nonzero'
              d='M1.855 8.233h30.29c1.025 0 1.855.826 1.855 1.845v6.95H0v-6.95C0 9.06.83 8.233 1.855 8.233z'
              transform='translate(-916 -3952) translate(916 3955) translate(4)'
            />
            <path
              fill='#3DB988'
              fillRule='nonzero'
              d='M14.901 8.233H18.596V17.028H14.901z'
              transform='translate(-916 -3952) translate(916 3955) translate(4)'
            />
          </g>
          <path
            fill='#98632E'
            fillRule='nonzero'
            d='M20.643 31.012c.508 0 1.04-.044 1.595-.132v-2.008c.27-.103.62-.261 1.048-.475.428-.213.845-.493 1.25-.838.404-.346.75-.77 1.035-1.27.286-.5.429-1.095.429-1.787 0-1.398-.484-2.497-1.452-3.3-.969-.801-2.405-1.202-4.31-1.202-.38 0-.738.011-1.071.033-.334.022-.667.063-1 .121-.334.06-.675.137-1.024.232-.35.096-.73.21-1.143.342.032.442.119.868.262 1.28.143.412.325.81.548 1.192.253-.088.496-.166.726-.232.23-.066.456-.125.678-.176.223-.052.465-.089.726-.11.262-.023.56-.034.893-.034.81 0 1.46.166 1.953.497.492.33.738.813.738 1.445 0 .427-.107.784-.322 1.07-.214.288-.488.527-.821.718-.333.191-.698.342-1.095.452-.397.11-.778.195-1.143.254v3.796c.476.088.976.132 1.5.132zM20.667 36c.555 0 1.135-.044 1.738-.132.095-.545.143-1.09.143-1.634 0-.514-.048-1.051-.143-1.61-.603-.089-1.19-.133-1.762-.133-.572 0-1.15.044-1.738.132-.095.56-.143 1.104-.143 1.634 0 .53.048 1.066.143 1.61.587.089 1.174.133 1.762.133z'
            transform='translate(-916 -3952) translate(916 3955)'
          />
          <path
            fill='url(#23sr62kz0c)'
            fillRule='nonzero'
            d='M38.5 2c.735 2.963 1.424 5.087 2.066 6.372C41.21 9.657 42.353 11.2 44 13c-1.646 1.802-2.79 3.344-3.433 4.629-.642 1.285-1.331 3.409-2.066 6.372-.682-2.862-1.37-4.986-2.063-6.372-.693-1.387-1.84-2.93-3.437-4.628l.249-.267c1.468-1.594 2.531-3.047 3.188-4.36C37.13 6.985 37.817 4.861 38.5 2z'
            transform='translate(-916 -3952) translate(916 3955)'
          />
          <path
            fill='url(#19rv1hpfyd)'
            fillRule='nonzero'
            d='M2.187 30.765c.441-.819.879-2.074 1.313-3.765.468 1.751.906 3.006 1.315 3.765.409.76 1.137 1.671 2.185 2.735l-.193.198c-.945.98-1.609 1.825-1.992 2.537-.409.759-.847 2.014-1.315 3.765-.434-1.691-.872-2.946-1.313-3.765-.441-.82-1.17-1.731-2.187-2.735 1.017-1.004 1.746-1.915 2.187-2.735z'
            transform='translate(-916 -3952) translate(916 3955)'
          />
        </g>
      </g>
    </g>
  </svg>
)
export const exclamationIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 27 27'>
    <g fill='none' fillRule='evenodd' transform='translate(1 1)'>
      <text fill='#D61717' fontFamily='AvenirNext-DemiBold, Avenir Next' fontSize='16' fontWeight='500'>
        <tspan x='10.28' y='18'>
          !
        </tspan>
      </text>
      <rect width='25' height='25' stroke='#D61717' strokeWidth='2' rx='12.5' />
    </g>
  </svg>
)

export const geofenceEventIcon = () => {
  return (
    <svg className='custom-icon' xmlns='http://www.w3.org/2000/svg' width='13.5' height='18' viewBox='0 0 13.5 18'>
      <g fill='none' fillRule='evenodd'>
        <path
          stroke='#fff'
          strokeWidth='1.5'
          d='M5.986 15.252A.037.037 0 0 1 6 15.25c.03 0 .008.011.01.008l2.093-2.998c1.036-1.493 1.72-2.498 2.046-3.008.448-.7.744-1.278.888-1.72.14-.43.213-.94.213-1.532 0-.95-.235-1.818-.708-2.618a5.365 5.365 0 0 0-1.924-1.924A5.042 5.042 0 0 0 6 .75c-.95 0-1.818.235-2.618.708a5.365 5.365 0 0 0-1.924 1.924A5.042 5.042 0 0 0 .75 6c0 .591.072 1.102.213 1.533.144.441.44 1.018.887 1.719.327.51 1.011 1.515 2.044 3.003.852 1.205 1.549 2.204 2.092 2.997z'
        />
        <path
          fill='#fff'
          d='M5.188 6.986l2.92-2.91a.2.2 0 0 1 .282 0l.73.723a.2.2 0 0 1 .038.23l-.038.054-3.79 3.772a.2.2 0 0 1-.283 0L2.798 6.608a.2.2 0 0 1-.037-.231l.038-.053.74-.733a.2.2 0 0 1 .23-.037l.053.039 1.366 1.393z'
        />
      </g>
    </svg>
  )
}

export const check = className => {
  return (
    <svg
      key='check-icon'
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='18'
      viewBox='0 0 23 18'
      className={className}>
      <path
        fillRule='evenodd'
        d='M8 12.032L4.495 8.505A2.115 2.115 0 0 0 1.5 8.5a2.12 2.12 0 0 0 0 3L8 17.997 21.501 4.5a2.121 2.121 0 0 0 0-3 2.12 2.12 0 0 0-3 .002L8 12.032z'
      />
    </svg>
  )
}
export const closeIcon = () => {
  return (
    <svg key='close-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
      <path
        fillRule='evenodd'
        d='M9 6.299l5.74-5.74a1.91 1.91 0 0 1 2.7 2.701L11.702 9l5.74 5.74a1.91 1.91 0 0 1-2.701 2.7L9 11.702l-5.74 5.74a1.91 1.91 0 0 1-2.7-2.701L6.298 9 .559 3.26A1.91 1.91 0 1 1 3.26.56L9 6.298z'
      />
    </svg>
  )
}

export const complianceIcon = () => {
  return (
    <svg key='dashboard-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' />
      <path fill='none' d='M0 0h24v24H0z' />
    </svg>
  )
}

export const communicationIcon = () => {
  return (
    <svg key='comm-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' />
      <path d='M0 0h24v24H0z' fill='none' />
    </svg>
  )
}

export const paymentsIcon = () => {
  return (
    <svg key='payments-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M0 0h24v24H0z' fill='none' />
      <path d='M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' />
    </svg>
  )
}

export const participantsIcon = () => {
  return (
    <svg key='ptp-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M0 0h24v24H0z' fill='none' />
      <path d='M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' />
    </svg>
  )
}

export const instrumentsIcon = () => {
  return (
    <svg key='instruments-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path fill='none' d='M0 0h24v24H0V0z' />
      <path d='M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-4.2-5.78v1.75l3.2-2.99L12.8 9v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z' />
    </svg>
  )
}

export const consentsIcon = () => {
  return (
    <svg key='consents-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M0 0h24v24H0z' fill='none' />
      <path d='M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' />
    </svg>
  )
}

export const usersIcon = () => {
  return (
    <svg key='users-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' />
      <path d='M0 0h24v24H0z' fill='none' />
    </svg>
  )
}

export const sitesIcon = () => {
  return (
    <svg key='site-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' />
      <path d='M0 0h24v24H0z' fill='none' />
    </svg>
  )
}

export const systemNotyIcon = () => {
  return (
    <svg key='system-noty-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path d='M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z' />
      <path fill='none' d='M0 0h24v24H0V0z' />
    </svg>
  )
}

export const auditReportIcon = () => {
  return (
    <svg key='audit-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'>
      <path fill='none' d='M0 0h24v24H0V0z' />
      <path d='M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z' />
    </svg>
  )
}

export const externalLinkIcon = () => {
  return (
    <svg key='external-link-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 512 512'>
      <path fill='none' d='M0 0h24v24H0V0z' />
      <path d='M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z' />
    </svg>
  )
}

export const settingsIcon = () => {
  return (
    <svg key='settings-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0V0z' />
      <path d='M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z' />
    </svg>
  )
}

export const myProfileIcon = () => {
  return (
    <svg width='24px' height='24px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id='0:-icon-/-white-/-user-solid' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <rect x='0' y='0' width='40' height='40' />
        <path
          d='M20,4 C21.791667,4 23.458333,4.44791698 25,5.34375 C26.541667,6.23958302 27.760417,7.45833302 28.65625,9 C29.552083,10.541667 30,12.208333 30,14 C30,15.791667 29.552083,17.458333 28.65625,19 C27.760417,20.541667 26.541667,21.760417 25,22.65625 C23.458333,23.552083 21.791667,24 20,24 C18.208333,24 16.541667,23.552083 15,22.65625 C13.458333,21.760417 12.239583,20.541667 11.34375,19 C10.447917,17.458333 10,15.791667 10,14 C10,12.208333 10.447917,10.541667 11.34375,9 C12.239583,7.45833302 13.458333,6.23958302 15,5.34375 C16.541667,4.44791698 18.208333,4 20,4 Z M31.4375,24.875 C32.770833,25.208333 33.864583,25.916667 34.71875,27 C35.572917,28.083333 36,29.3125 36,30.6875 L36,33 C36,33.833333 35.708333,34.541667 35.125,35.125 C34.541667,35.708333 33.833333,36 33,36 L7,36 C6.16666698,36 5.45833302,35.708333 4.875,35.125 C4.29166698,34.541667 4,33.833333 4,33 L4,30.6875 C4,29.3125 4.42708302,28.083333 5.28125,27 C6.13541698,25.916667 7.22916698,25.208333 8.5625,24.875 L13,23.75 C14.958333,25.166667 17.166667,25.916667 19.625,26 C22.333333,26.083333 24.791667,25.333333 27,23.75 L31.4375,24.875 Z'
          id='0:-icon-/-user-solid'
        />
      </g>
    </svg>
  )
}

export const dchLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlSpace='preserve'
      width='5.55555in'
      height='5.55555in'
      version='1.1'
      viewBox='0 0 5556 5556'>
      <g id='Layer_x0020_1'>
        <metadata id='CorelCorpID_0Corel-Layer' />
        <path
          className='fil0'
          d='M4001 2073c-284,0 -514,-230 -514,-514 0,-284 230,-514 514,-514 284,0 514,230 514,514 0,284 -230,514 -514,514zm-876 2444l0 -719c404,-143 695,-529 695,-982l694 0c0,840 -597,1541 -1389,1701zm-694 0c-792,-161 -1388,-861 -1388,-1701l694 0c0,452 290,838 694,982l0 719zm-873 -3472c284,0 514,230 514,514 0,284 -230,514 -514,514 -284,0 -514,-230 -514,-514 0,-284 230,-514 514,-514zm-1557 -1045l0 5556 5556 0 0 -5556 -5556 0z'
        />
      </g>
    </svg>
  )
}

export const logout = () => {
  return (
    <svg width='24px' height='24px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id='0:-icon-/-white-/-signout' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <path
          d='M24.2361111,31.5625 C23.9490738,31.854167 23.6005294,32 23.1904762,32 C22.780423,32 22.4318786,31.854167 22.1448413,31.5625 C21.8578039,31.270833 21.7142857,30.916667 21.7142857,30.5 L21.7142857,24.5 L13.3492063,24.5 C12.9391531,24.5 12.5906088,24.354167 12.3035714,24.0625 C12.0165341,23.770833 11.8730159,23.416667 11.8730159,23 L11.8730159,17 C11.8730159,16.583333 12.0165341,16.229167 12.3035714,15.9375 C12.5906088,15.645833 12.9391531,15.5 13.3492063,15.5 L21.7142857,15.5 L21.7142857,9.5 C21.7142857,9.08333302 21.8578039,8.72916698 22.1448413,8.4375 C22.4318786,8.14583302 22.780423,8 23.1904762,8 C23.6005294,8 23.9490738,8.14583302 24.2361111,8.4375 L34.5694444,18.9375 C34.8564818,19.229167 35,19.583333 35,20 C35,20.416667 34.8564818,20.770833 34.5694444,21.0625 L24.2361111,31.5625 Z M15.8095238,31.25 C15.8095238,31.458333 15.7377642,31.635417 15.594246,31.78125 C15.4507278,31.927083 15.2764547,32 15.0714286,32 L9.9047619,32 C8.26454995,32 6.87037068,31.416667 5.72222222,30.25 C4.57407376,29.083333 4,27.666667 4,26 L4,14 C4,12.333333 4.57407376,10.916667 5.72222222,9.75 C6.87037068,8.58333302 8.26454995,8 9.9047619,8 L15.0714286,8 C15.2764547,8 15.4507278,8.07291698 15.594246,8.21875 C15.7377642,8.36458302 15.8095238,8.54166698 15.8095238,8.75 L15.8095238,11.25 C15.8095238,11.458333 15.7377642,11.635417 15.594246,11.78125 C15.4507278,11.927083 15.2764547,12 15.0714286,12 L9.9047619,12 C9.37169281,12 8.91038329,12.197917 8.52083333,12.59375 C8.13128338,12.989583 7.93650794,13.458333 7.93650794,14 L7.93650794,26 C7.93650794,26.541667 8.13128338,27.010417 8.52083333,27.40625 C8.91038329,27.802083 9.37169281,28 9.9047619,28 L15.0714286,28 C15.2764547,28 15.4507278,28.072917 15.594246,28.21875 C15.7377642,28.364583 15.8095238,28.541667 15.8095238,28.75 L15.8095238,31.25 Z'
          id='0:-icon-/-signout'
        />
      </g>
    </svg>
  )
}

export const studiesIcon = () => {
  return (
    <svg key='studies-icon' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <path d='M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' />
      <path d='M0 0h24v24H0z' fill='none' />
    </svg>
  )
}

export const homeIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <path d='M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' />
      <path d='M0 0h24v24H0z' fill='none' />
    </svg>
  )
}

export const geofencesIcon = () => {
  return (
    <svg
      key='geofence-icon'
      width='18px'
      height='18px'
      viewBox='0 0 20 20'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'>
      <path d='M14.7,5.4 C14.7,2.421 12.279,0 9.3,0 C6.321,0 3.9,2.421 3.9,5.4 C3.9,9.45 9.3,15.3 9.3,15.3 C9.3,15.3 14.7,9.45 14.7,5.4 Z M7.5,5.4 C7.5,4.41 8.31,3.6 9.3,3.6 C10.29,3.6 11.1,4.41 11.1,5.4 C11.1,6.39 10.299,7.2 9.3,7.2 C8.31,7.2 7.5,6.39 7.5,5.4 Z M3,16.2 L3,18 L15.6,18 L15.6,16.2 L3,16.2 Z' />
    </svg>
  )
}

export const virtualVisitIcon = () => (
  <svg key='virtualvisits-icon' xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'>
    <path
      fillRule='evenodd'
      d='M15.4 1c.88 0 1.6.72 1.6 1.6v9.6c0 .88-.72 1.6-1.6 1.6H4.2L1 17l.008-14.4c0-.88.712-1.6 1.592-1.6zm-4.807 3.5H5.818c-.771 0-1.418.635-1.418 1.448v3.2c0 .787.622 1.447 1.418 1.447h4.75c.771 0 1.418-.635 1.418-1.447v-.254l1.567.94c.249.152.572-.026.572-.33V5.591h.025c0-.305-.323-.482-.572-.33l-1.567.94v-.254c0-.788-.622-1.448-1.418-1.448z'
    />
  </svg>
)

export const casesIcon = () => {
  return (
    <svg key='case-icon' xmlns='http://www.w3.org/2000/svg' width='16' height='14' viewBox='0 0 16 14'>
      <path d='M10 8h6v4.5c0 .417-.146.77-.438 1.063A1.447 1.447 0 0 1 14.5 14h-13c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 0 1 0 12.5V8h6v.625c0 .104.036.193.11.266.072.073.16.109.265.109h3.25a.362.362 0 0 0 .266-.11.362.362 0 0 0 .109-.265V8zm6-3.5V7H0V4.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 1.5 3H4V1.5c0-.417.146-.77.438-1.063A1.447 1.447 0 0 1 5.5 0h5c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062V3h2.5c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062zM10 2H6v1h4V2z' />
    </svg>
  )
}

// new triangle icon that sits under the number value input in numeric rating scale
export const triangleIcon = className => {
  return (
    <svg
      className={className}
      width='12px'
      height='12px'
      viewBox='0 0 12 12'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'>
      <g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='Create-Survey----NumericRatingScale-8' transform='translate(-224.000000, -641.000000)' fill='#D8D8D8'>
          <polygon id='Triangle' points='230 641 236 653 224 653' />
        </g>
      </g>
    </svg>
  )
}

export const sidebarNotificationIcon = key => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='26'
    height='18'
    viewBox='0 0 26 18'
    className='sidebarNotificationIcon'
    key={key}>
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g>
            <g transform='translate(-262 -4437) translate(64 4221) translate(0 205) translate(198 11)'>
              <rect width='26' height='18' fill='#CB2D2D' rx='3' />
              <path
                fill='#FFF'
                fillRule='nonzero'
                d='M13.835 11.032l.21-6.692h-2.352l.196 6.692h1.946zm-.966 3.122c.77 0 1.316-.448 1.316-1.204s-.546-1.204-1.316-1.204c-.784 0-1.33.448-1.33 1.204s.546 1.204 1.33 1.204z'
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const amazonIncentives = (
  <svg xmlns='http://www.w3.org/2000/svg' width='125' height='76' viewBox='0 0 125 76'>
    <g fill='none'>
      <path
        fill='#231F20'
        d='M8 0h109c4.418 0 8 3.582 8 8v60c0 4.418-3.582 8-8 8H8c-4.418 0-8-3.582-8-8V8c0-4.418 3.582-8 8-8z'
      />
      <path
        fill='#FFF'
        d='M68.344 34.942v-1.635c.002-.248.207-.415.456-.415h8.032c.259 0 .464.171.464.414v1.404c-.003.232-.22.54-.605 1.028l-4.164 5.42c1.545-.032 3.18.178 4.584.899.317.163.403.4.427.637v1.748c0 .241-.29.52-.59.375-2.475-1.185-5.757-1.314-8.49.014-.28.137-.572-.137-.572-.378V42.79c0-.265.005-.72.299-1.124l4.82-6.311h-4.196c-.257 0-.462-.167-.465-.413zM39.042 45.16h-2.444c-.232-.013-.42-.173-.437-.376l.002-11.45c0-.228.21-.412.471-.412h2.276c.238.011.43.175.445.384v1.496h.045c.591-1.446 1.71-2.122 3.215-2.122 1.53 0 2.485.676 3.171 2.122.594-1.446 1.939-2.122 3.377-2.122 1.027 0 2.144.386 2.83 1.254.776.96.616 2.36.616 3.587l-.001 7.226c0 .23-.213.413-.473.413h-2.44c-.246-.013-.439-.191-.439-.41v-6.072c0-.481.044-1.684-.07-2.144-.184-.77-.731-.987-1.438-.987-.591 0-1.208.361-1.46.94-.25.578-.228 1.54-.228 2.191v6.069c0 .23-.211.413-.472.413h-2.44c-.246-.013-.44-.191-.44-.41l-.003-6.072c0-1.278.23-3.156-1.504-3.156-1.758 0-1.689 1.833-1.689 3.156v6.069c-.001.23-.208.413-.47.413zm45.171-12.48c3.624 0 5.59 2.843 5.59 6.456 0 3.492-2.171 6.266-5.59 6.266-3.56 0-5.5-2.848-5.5-6.388 0-3.563 1.962-6.334 5.5-6.334zm.023 2.336c-1.804 0-1.919 2.243-1.919 3.636 0 1.398-.023 4.384 1.896 4.384 1.89 0 1.98-2.408 1.98-3.874 0-.965-.045-2.12-.365-3.037-.273-.796-.821-1.109-1.592-1.109zm10.27 10.144h-2.438c-.246-.013-.438-.191-.438-.41l-.005-11.454c.021-.21.223-.374.47-.374h2.27c.214.01.39.143.434.32v1.75h.046c.684-1.564 1.638-2.312 3.327-2.312 1.097 0 2.17.362 2.855 1.351.635.912.635 2.456.635 3.563V44.8c-.028.205-.228.362-.463.362h-2.454c-.223-.012-.408-.166-.436-.362v-6.216c0-1.25.162-3.084-1.53-3.084-.594 0-1.135.363-1.41.917-.342.7-.387 1.396-.387 2.167v6.165c-.006.23-.217.413-.477.413zm-60.253-2.1c-.445-.566-.92-1.022-.92-2.067v-3.475c0-1.47.115-2.822-1.076-3.836-.938-.822-2.492-1.112-3.682-1.112-2.327 0-4.92.793-5.465 3.415-.058.28.164.426.365.467l2.369.234c.22-.01.382-.21.424-.41.204-.905 1.033-1.34 1.965-1.34.502 0 1.073.17 1.372.58.343.457.297 1.087.297 1.618v.287c-1.419.145-3.271.242-4.595.773-1.532.605-2.606 1.834-2.606 3.647 0 2.319 1.6 3.478 3.656 3.478 1.741 0 2.688-.375 4.031-1.622.444.586.59.869 1.4 1.487.183.088.416.081.578-.052l.006.005c.488-.397 1.376-1.1 1.873-1.482.198-.15.163-.394.008-.596zm-4.81-1.003c-.389.625-1.004 1.012-1.69 1.012-.938 0-1.487-.653-1.487-1.616 0-1.898 1.869-2.243 3.636-2.243v.482c0 .867.022 1.592-.458 2.365zm36.85 1.002c-.449-.565-.924-1.02-.924-2.066v-3.475c0-1.47.115-2.822-1.076-3.836-.934-.822-2.49-1.112-3.678-1.112-2.326 0-4.921.793-5.465 3.415-.058.28.164.426.364.467l2.368.234c.223-.01.384-.21.426-.41.205-.905 1.03-1.34 1.964-1.34.502 0 1.075.17 1.371.58.342.457.296 1.087.296 1.618v.287c-1.416.145-3.268.242-4.593.773-1.532.605-2.607 1.834-2.607 3.647 0 2.319 1.599 3.478 3.658 3.478 1.736 0 2.688-.375 4.03-1.622.443.586.59.869 1.4 1.487.184.088.415.081.576-.052l.006.005c.49-.397 1.377-1.1 1.876-1.482.2-.15.165-.394.007-.596zm-4.811-1.002c-.387.625-1.005 1.012-1.691 1.012-.938 0-1.484-.653-1.484-1.616 0-1.898 1.866-2.243 3.633-2.243v.482c0 .867.023 1.592-.458 2.365z'
      />
      <g fill='#F9A51B'>
        <path
          d='M37.354 4.06c-4.603 3.123-11.016 4.81-16.673 4.81C12.756 8.87 5.693 6.143.25 1.47-.252 1.04.073.532.698.874c5.92 3.255 13.016 5.16 20.46 5.16 5.02 0 10.353-.951 15.42-3 1.108-.45 1.568.487.776 1.025z'
          transform='translate(34.545 45.403)'
        />
        <path
          d='M39.321 1.95c-.582-.706-3.833-.333-5.294-.17-.44.052-.51-.316-.11-.582C36.51-.525 40.76-.023 41.252.546c.497.585-.131 4.64-2.56 6.574-.375.3-.727.137-.562-.255.545-1.3 1.77-4.21 1.191-4.914z'
          transform='translate(34.545 45.403)'
        />
      </g>
      <path
        fill='#FFF'
        d='M104.622 43.563c.237 0 .439.083.605.25.166.165.25.366.25.601 0 .237-.084.438-.25.604-.166.167-.367.25-.605.25-.237 0-.438-.083-.604-.25-.165-.166-.248-.368-.248-.604 0-.235.083-.436.25-.601.166-.167.368-.25.602-.25zm.988.849c0-.272-.097-.504-.289-.696-.193-.192-.427-.287-.7-.287-.271 0-.503.095-.696.287-.192.193-.289.424-.289.696 0 .274.096.507.287.7.192.194.425.29.698.29.273 0 .507-.096.7-.29.192-.193.29-.426.29-.7zm-.726-.213c0 .081-.038.137-.113.166-.042.017-.103.024-.185.024h-.175v-.386h.165c.108 0 .186.012.235.039.048.027.073.078.073.157zm-.66-.33v1.08h.187v-.426h.153c.103 0 .175.012.216.034.07.041.104.123.104.248v.086l.004.034.002.013c.002.003.002.007.003.01h.178l-.007-.013c-.006-.01-.009-.028-.01-.056-.002-.029-.002-.055-.002-.08v-.08c0-.054-.021-.11-.06-.168-.039-.056-.1-.092-.185-.105.067-.01.119-.028.156-.052.072-.046.108-.117.108-.213 0-.136-.057-.227-.17-.274-.062-.025-.161-.038-.296-.038h-.38z'
      />
    </g>
  </svg>
)

export const doNotEnterIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'>
    <path
      fill='#CB2D2D'
      fillRule='evenodd'
      d='M5.85 1.2c.838 0 1.613.21 2.325.628.712.419 1.278.984 1.697 1.697.419.712.628 1.487.628 2.325 0 .838-.21 1.613-.628 2.325-.419.712-.985 1.278-1.697 1.697-.713.419-1.487.628-2.325.628-.838 0-1.612-.21-2.325-.628-.712-.419-1.278-.985-1.697-1.697C1.41 7.462 1.2 6.688 1.2 5.85c0-.838.21-1.612.628-2.325.419-.712.984-1.278 1.697-1.697C4.237 1.41 5.012 1.2 5.85 1.2zM3.375 6.6h4.95c.062 0 .116-.022.16-.066.043-.043.065-.097.065-.159v-1.05c0-.062-.022-.116-.066-.16-.043-.043-.097-.065-.159-.065h-4.95c-.062 0-.116.022-.16.066-.043.043-.065.097-.065.159v1.05c0 .062.022.116.066.16.043.043.097.065.159.065z'
    />
  </svg>
)
export const deniedIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'>
    <path
      fill='#F27B21'
      fillRule='evenodd'
      d='M6.15 1.2c.838 0 1.612.21 2.325.628.713.419 1.278.984 1.697 1.697.419.712.628 1.487.628 2.325 0 .838-.21 1.613-.628 2.325-.419.712-.985 1.278-1.697 1.697-.712.419-1.487.628-2.325.628-.838 0-1.613-.21-2.325-.628-.713-.419-1.278-.985-1.697-1.697C1.71 7.462 1.5 6.688 1.5 5.85c0-.838.21-1.612.628-2.325.419-.712.984-1.278 1.697-1.697C4.537 1.41 5.312 1.2 6.15 1.2zm2.438 2.213c-.4-.4-.86-.682-1.379-.844-.518-.163-1.046-.203-1.584-.122-.538.081-1.025.272-1.463.572l4.82 4.819c.3-.438.49-.925.571-1.463.081-.538.04-1.066-.122-1.584-.162-.52-.444-.979-.843-1.379zM3.713 8.287c.4.4.859.682 1.378.844.518.163 1.046.203 1.584.122.538-.081 1.025-.272 1.462-.572L3.32 3.863c-.3.437-.49.924-.572 1.462-.081.537-.04 1.066.122 1.584.162.52.444.979.843 1.378z'
    />
  </svg>
)

export const waveForm = (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='12' viewBox='0 0 14 12'>
    <defs>
      <filter id='4np98mrcsa'>
        <feColorMatrix
          in='SourceGraphic'
          // values='0 0 0 0 0.329412 0 0 0 0 0.329412 0 0 0 0 0.329412 0 0 0 1.000000 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd' filter='url(#4np98mrcsa)' transform='translate(-793 -487)'>
      <path
        fill='#cacaca'
        fillRule='nonzero'
        d='M800.106 487c.207 0 .374.167.374.374v10.472c0 .207-.167.374-.374.374h-1.122c-.207 0-.374-.167-.374-.374v-10.472c0-.207.167-.374.374-.374h1.122zm-2.805 1.87c.207 0 .374.167.374.374v6.732c0 .207-.167.374-.374.374h-1.122c-.207 0-.374-.167-.374-.374v-6.732c0-.207.167-.374.374-.374h1.122zm8.415 0c.207 0 .374.167.374.374v6.732c0 .207-.167.374-.374.374h-1.122c-.207 0-.374-.167-.374-.374v-6.732c0-.207.167-.374.374-.374h1.122zm-2.805.935c.207 0 .374.167.374.374v4.862c0 .207-.167.374-.374.374h-1.122c-.207 0-.374-.167-.374-.374v-4.862c0-.207.167-.374.374-.374h1.122zm-8.415.935c.207 0 .374.167.374.374v2.992c0 .207-.167.374-.374.374h-1.122c-.207 0-.374-.167-.374-.374v-2.992c0-.207.167-.374.374-.374h1.122z'
      />
    </g>
  </svg>
)

export const uploadIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'>
    <defs>
      <filter id='2zeaouajqa'>
        <feColorMatrix in='SourceGraphic' />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd' filter='url(#2zeaouajqa)' transform='translate(-266 -196)'>
      <g fill='#545454'>
        <path
          fillRule='nonzero'
          d='M16.344 19.994v1.262c0 .221-.18.4-.4.4H5.056c-.22 0-.4-.179-.4-.4v-1.262c0-.221.18-.4.4-.4h10.888c.22 0 .4.179.4.4z'
          transform='translate(266.5 196)'
        />
        <path
          d='M4.093 11.583l-.715-.722c-.152-.153-.228-.34-.228-.558 0-.219.076-.405.228-.558L9.685 3.38c.152-.153.336-.23.553-.23.216 0 .4.077.552.23l6.307 6.365c.152.153.228.34.228.558 0 .219-.076.405-.228.558l-.715.722c-.152.175-.336.257-.553.246-.216-.011-.4-.093-.552-.246l-3.739-3.938v9.418c0 .218-.076.404-.228.557-.151.153-.336.23-.552.23h-1.04c-.217 0-.402-.077-.553-.23-.152-.153-.228-.339-.228-.558V7.646l-3.739 3.938c-.151.153-.336.235-.552.246-.217.01-.401-.071-.553-.246z'
          transform='translate(266.5 196)'
        />
      </g>
    </g>
  </svg>
)

/** Upload tray icon for Timed Matching Grid "Upload symbols zip" */
export const tmgUploadSymbolsZipIcon = (
  <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8.5 2.125V10.625'
      stroke='#26346B'
      strokeWidth='1.41667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.0413 5.66667L8.49967 2.125L4.95801 5.66667'
      stroke='#26346B'
      strokeWidth='1.41667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.875 10.625V13.4583C14.875 13.8341 14.7257 14.1944 14.4601 14.4601C14.1944 14.7257 13.8341 14.875 13.4583 14.875H3.54167C3.16594 14.875 2.80561 14.7257 2.53993 14.4601C2.27426 14.1944 2.125 13.8341 2.125 13.4583V10.625'
      stroke='#26346B'
      strokeWidth='1.41667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

/** Info icon for Timed Matching Grid key format helper note */
export const tmgKeyFormatInfoIcon = (
  <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6.56998 12.9749C9.59387 12.9749 12.0452 10.5236 12.0452 7.49966C12.0452 4.47577 9.59387 2.02441 6.56998 2.02441C3.54608 2.02441 1.09473 4.47577 1.09473 7.49966C1.09473 10.5236 3.54608 12.9749 6.56998 12.9749Z'
      stroke='#6B7280'
      strokeWidth='1.095'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.57031 9.6901V7.5'
      stroke='#6B7280'
      strokeWidth='1.095'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.57031 5.30957H6.57579'
      stroke='#6B7280'
      strokeWidth='1.095'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const tmgZipFileIcon = (
  <svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.7969 23.8337H19.4997C20.0743 23.8337 20.6254 23.6054 21.0317 23.1991C21.4381 22.7927 21.6663 22.2416 21.6663 21.667V8.667C21.6672 8.3237 21.6 7.98364 21.4688 7.66643C21.3375 7.34922 21.1447 7.06114 20.9015 6.81883L17.0145 2.93183C16.7722 2.68865 16.4841 2.49585 16.1669 2.36458C15.8497 2.23331 15.5096 2.16616 15.1663 2.167H6.49967C5.92504 2.167 5.37394 2.39527 4.96761 2.8016C4.56128 3.20793 4.33301 3.75903 4.33301 4.33367V16.792'
      stroke='#26346B'
      strokeWidth='2.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.167 2.16699V7.58366C15.167 7.87098 15.2811 8.14653 15.4843 8.34969C15.6875 8.55286 15.963 8.66699 16.2503 8.66699H21.667'
      stroke='#26346B'
      strokeWidth='2.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.66699 13.0003V11.917'
      stroke='#26346B'
      strokeWidth='2.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.66699 19.4997V17.333'
      stroke='#26346B'
      strokeWidth='2.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.66699 7.58333V6.5'
      stroke='#26346B'
      strokeWidth='2.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.66667 23.8333C9.86328 23.8333 10.8333 22.8633 10.8333 21.6667C10.8333 20.47 9.86328 19.5 8.66667 19.5C7.47005 19.5 6.5 20.47 6.5 21.6667C6.5 22.8633 7.47005 23.8333 8.66667 23.8333Z'
      stroke='#26346B'
      strokeWidth='2.16667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const tmgZipRemoveIcon = (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#tmgZipRemoveClip)'>
      <path
        d='M6.25 6.875V10.625'
        stroke='#C0392B'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.75 6.875V10.625'
        stroke='#C0392B'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.875 3.75V12.5C11.875 12.8315 11.7433 13.1495 11.5089 13.3839C11.2745 13.6183 10.9565 13.75 10.625 13.75H4.375C4.04348 13.75 3.72554 13.6183 3.49112 13.3839C3.2567 13.1495 3.125 12.8315 3.125 12.5V3.75'
        stroke='#C0392B'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.875 3.75H13.125'
        stroke='#C0392B'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 3.75V2.5C5 2.16848 5.1317 1.85054 5.36612 1.61612C5.60054 1.3817 5.91848 1.25 6.25 1.25H8.75C9.08152 1.25 9.39946 1.3817 9.63388 1.61612C9.8683 1.85054 10 2.16848 10 2.5V3.75'
        stroke='#C0392B'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='tmgZipRemoveClip'>
        <rect width='15' height='15' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const tmgZipReplaceIcon = (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M1.875 7.5C1.875 6.00816 2.46763 4.57742 3.52252 3.52252C4.57742 2.46763 6.00816 1.875 7.5 1.875C9.07253 1.88092 10.5819 2.49451 11.7125 3.5875L13.125 5'
      stroke='#3B4A63'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.125 1.875V5H10'
      stroke='#3B4A63'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.125 7.5C13.125 8.99184 12.5324 10.4226 11.4775 11.4775C10.4226 12.5324 8.99184 13.125 7.5 13.125C5.92747 13.1191 4.41811 12.5055 3.2875 11.4125L1.875 10'
      stroke='#3B4A63'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5 10H1.875V13.125'
      stroke='#3B4A63'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const tmgParticipantNoteInfoIcon = (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#tmg_participant_note_info)'>
      <path
        d='M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z'
        stroke='#6B7280'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M7.5 10V7.5' stroke='#6B7280' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M7.5 5H7.50625' stroke='#6B7280' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
    </g>
    <defs>
      <clipPath id='tmg_participant_note_info'>
        <rect width='15' height='15' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const tmgEditSequenceIcon = (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#tmg_edit_sequence_clip)'>
      <path
        d='M14.1156 4.54126C14.4681 4.18888 14.6662 3.71091 14.6662 3.2125C14.6663 2.71409 14.4683 2.23607 14.116 1.8836C13.7636 1.53112 13.2856 1.33307 12.7872 1.33301C12.2888 1.33295 11.8108 1.53088 11.4583 1.88326L2.56096 10.7826C2.40618 10.9369 2.29171 11.127 2.22763 11.3359L1.34696 14.2373C1.32973 14.2949 1.32843 14.3562 1.3432 14.4145C1.35796 14.4728 1.38824 14.5261 1.43083 14.5686C1.47341 14.6111 1.52671 14.6413 1.58507 14.656C1.64343 14.6707 1.70467 14.6693 1.7623 14.6519L4.6643 13.7719C4.87308 13.7084 5.06308 13.5947 5.21763 13.4406L14.1156 4.54126Z'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 3.33301L12.6667 5.99967'
        stroke='currentColor'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='tmg_edit_sequence_clip'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export const tmgSequenceLockedIcon = (
  <svg width='16' height='16' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='2.5' y='6.25' width='9' height='6.25' rx='1.25' stroke='#9CA3AF' strokeWidth='1.2' />
    <path
      d='M4.5 6.25V4.75C4.5 3.23122 5.73122 2 7.25 2C8.76878 2 10 3.23122 10 4.75V6.25'
      stroke='#9CA3AF'
      strokeWidth='1.2'
      strokeLinecap='round'
    />
  </svg>
)

export const tmgClearAllIcon = (
  <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14.875 14.8751H5.66669C5.4799 14.8755 5.29487 14.839 5.12225 14.7676C4.94963 14.6962 4.79282 14.5915 4.66086 14.4593L1.83177 11.6266C1.56619 11.361 1.41699 11.0007 1.41699 10.6251C1.41699 10.2494 1.56619 9.88913 1.83177 9.62347L8.91511 2.54013C9.04666 2.40852 9.20286 2.30412 9.37478 2.23289C9.54669 2.16166 9.73096 2.125 9.91704 2.125C10.1031 2.125 10.2874 2.16166 10.4593 2.23289C10.6312 2.30412 10.7874 2.40852 10.919 2.54013L15.1683 6.79014C15.4339 7.0558 15.5831 7.41607 15.5831 7.79172C15.5831 8.16737 15.4339 8.52764 15.1683 8.7933L9.09077 14.8751'
      stroke='#6B7280'
      strokeWidth='1.41667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.59961 7.85547L9.85278 14.1086'
      stroke='#6B7280'
      strokeWidth='1.41667'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const confettiIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='46' height='47' viewBox='0 0 46 47' className='confetti-icon'>
    <g fill='none' fillRule='evenodd'>
      <g strokeWidth='3'>
        <g>
          <path
            stroke='#FFEC77'
            d='M2.836 36.674C1.314 38.068.553 39.206.553 40.089c0 .882.761 2.02 2.283 3.415'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#DB86EA'
            d='M33.553 20.579c3.18-.527 5.252-1.202 6.216-2.027.964-.824 1.583-2.45 1.858-4.878'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#FF7DE8'
            d='M4.553 14.674c2.305 1.31 3.457 3.064 3.457 5.26 0 3.295-3.457 2.7-3.457 5.515 0 1.878 1.153 4.056 3.457 6.535'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#FFA545'
            d='M2.833 10.132C-.919 8.137-.944 6.07 2.76 3.93'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#DB86EA'
            d='M16.262 26.674c2.881 2.738 3.842 5.604 2.881 8.596-.96 2.993-2.824 4.006-5.59 3.04'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#EFC79C'
            d='M17.584 0c5.252.018 6.565 1.523 3.939 4.514-3.939 4.486-8.718-4.487-6.329 0C17.584 9 27.851 1.887 21.523 9'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#95DCFF'
            d='M30.681 15.195c-7.066-.136-11.088.55-12.069 2.06-.98 1.51 1.046 3.898 6.078 7.166'
            transform='translate(-1039 -983) translate(1041 985)'
          />
          <path
            stroke='#8FF58D'
            d='M31.166 30.674c-2.357 3.666-3.03 5.5-2.018 5.5 1.518 0 7.254-5.5 4.386 0-2.868 5.5-6.404 5.5-4.386 5.5s11.83-7.93 7.688 0'
            transform='translate(-1039 -983) translate(1041 985)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const blockTypeIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='16' viewBox='0 0 22 16'>
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g fill='#ffffff' fillRule='nonzero' transform='translate(-932 -481) translate(932 481)'>
            <path d='M8.717 0H1.04C.803 0 .612.176.612.393V2.75c0 .217.191.393.427.393h.853c.235 0 .426-.176.426-.393v-.786h1.494V9.43H2.745c-.236 0-.427.175-.427.392v.786c0 .217.191.393.427.393h4.266c.236 0 .427-.176.427-.393v-.786c0-.217-.191-.392-.427-.392H5.944V1.964h1.494v.786c0 .217.19.393.426.393h.853c.236 0 .427-.176.427-.393V.393C9.144.176 8.953 0 8.717 0z' />
            <path d='M13.65 7h-6.3c-.193 0-.35.112-.35.25v1.5c0 .138.157.25.35.25h.7c.193 0 .35-.112.35-.25v-.5h1.225V13H8.75c-.193 0-.35.112-.35.25v.5c0 .138.157.25.35.25h3.5c.193 0 .35-.112.35-.25v-.5c0-.138-.157-.25-.35-.25h-.875V8.25H12.6v.5c0 .138.157.25.35.25h.7c.193 0 .35-.112.35-.25v-1.5c0-.138-.157-.25-.35-.25z' />
          </g>
          <g fill='#ffffff'>
            <path
              d='M.332 0h4.336c.145 0 .246.074.302.222.056.148.034.275-.067.382l-2.168 2.29C2.668 2.963 2.59 3 2.5 3s-.168-.036-.235-.107L.097.603C-.003.498-.026.37.03.223.086.074.187 0 .332 0z'
              transform='translate(-932 -481) translate(932 481) translate(17 7)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const giftCardIcon = fillColor => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='22'
    viewBox='0 0 36 22'
    className={fillColor === '#1C2358' ? 'gift-card-icon' : 'gift-card-pay-icon'}>
    <g fill='none' fillRule='evenodd'>
      <g>
        <g>
          <g transform='translate(-854 -4488) translate(781 4454) translate(73 34)'>
            <rect width='36' height='22' fill={fillColor} rx='2' />
            <path fill='#FFF' d='M0 12H36V17H0z' />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const donationIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='35' height='31' viewBox='0 0 35 31' className='donation-icon'>
    <g fill='none' fillRule='evenodd'>
      <g fill='#1C2358'>
        <g>
          <path
            d='M288.47 35.737l3.298.866c.23.053.395.255.403.49 0 .279-.249.509-.554.509h-2.164c-.233 0-.463-.046-.68-.133-.318-.134-.685-.103-.93.12l-1.154 1.06c-.053.047-.1.101-.136.161-.097.158-.126.347-.082.526.045.179.159.333.317.427.64.383 1.356.62 2.097.697v1.071c0 .533.476.969 1.056.969h1.055c.58 0 1.056-.436 1.056-.969v-1.065c2.001-.218 3.515-1.877 3.251-3.815-.191-1.392-1.365-2.5-2.829-2.888l-3.298-.866c-.23-.053-.395-.255-.402-.49 0-.279.248-.509.554-.509h2.163c.234 0 .465.046.682.133.318.134.686.103.93-.12l1.154-1.06c.052-.046.096-.099.132-.158.097-.157.127-.346.083-.526-.043-.18-.157-.334-.316-.43-.64-.381-1.356-.62-2.098-.695v-1.073c0-.533-.475-.969-1.055-.969h-1.056c-.58 0-1.055.436-1.055.969v1.065c-1.998.218-3.515 1.877-3.251 3.815.19 1.392 1.367 2.5 2.83 2.888zm15.289 11.128l-5.615 4.475c-.689.55-1.547.85-2.43.847h-7.187c-.537 0-.972-.433-.972-.968 0-.535.435-.969.972-.969h4.758c.966 0 1.866-.66 2.02-1.61.019-.11.028-.22.028-.331-.002-1.069-.872-1.934-1.945-1.934h-9.722c-1.64 0-3.229.562-4.502 1.592l-2.826 2.283h-3.366c-.537 0-.972.434-.972.969v5.812c0 .535.435.969.972.969h21.678c.884 0 1.74-.298 2.431-.848l9.19-7.326c.447-.356.713-.891.728-1.462.015-.57-.223-1.12-.651-1.499-.718-.647-1.836-.605-2.59 0z'
            transform='translate(-1053 -4481) translate(781 4454)'
          />
        </g>
      </g>
    </g>
  </svg>
)

export const ribbonIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='46' height='25' viewBox='0 0 46 25' className='ribbon-icon'>
    <g fill='none' fillRule='evenodd'>
      <g stroke='#313D98' strokeWidth='3'>
        <g>
          <g>
            <path
              d='M21 11.55C11.973 0 5.376-2.888 1.21 2.887-2.957 8.662 3.64 11.55 21 11.55z'
              transform='translate(-317 -5594) translate(311 5534) translate(8 62)'
            />
            <path
              d='M42 11.55C32.973 0 26.376-2.888 22.21 2.887 18.043 8.662 24.64 11.55 42 11.55z'
              transform='translate(-317 -5594) translate(311 5534) translate(8 62) matrix(-1 0 0 1 63 0)'
            />
            <path
              d='M21 11.55C17.323 17.85 12.073 21 5.25 21'
              transform='translate(-317 -5594) translate(311 5534) translate(8 62)'
            />
            <path
              d='M36.75 11.55C33.073 17.85 27.823 21 21 21'
              transform='translate(-317 -5594) translate(311 5534) translate(8 62) matrix(-1 0 0 1 57.75 0)'
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const virtualVisitsIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width='224'
      height='100'
      viewBox='0 0 224 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.09375' width='223.908' height='100' fill='#F6F8F9' />
      <rect x='57.7508' y='12.7' width='108.59' height='74.6' rx='8.3' stroke='#E0E0E0' strokeWidth='1.4' />
      <rect x='138.562' y='31' width='61.8692' height='69' fill='#ECEFF0' />
      <rect x='144.457' y='37' width='50.0846' height='63' fill='#FAFBFB' />
      <path d='M151.819 46.5H187.173' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <path d='M151.819 51.5H187.173' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <path d='M151.819 56.5H187.173' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <path d='M151.819 61.5H187.173' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <rect x='120.887' y='42' width='61.8692' height='58' fill='#ECEFF0' />
      <rect x='126.777' y='48' width='50.0846' height='52' fill='#FAFBFB' />
      <path d='M134.143 57.5H169.497' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <path d='M134.143 62.5H169.497' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <path d='M134.143 67.5H169.497' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <path d='M134.143 72.5H169.497' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
      <g opacity='0.8'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M150.299 91.5982L146.199 87.4264C146.085 87.3092 146.027 87.1584 146.027 86.9741C146.027 86.7898 146.085 86.639 146.199 86.5217L147.108 85.617C147.222 85.483 147.365 85.416 147.537 85.416C147.709 85.416 147.861 85.483 147.991 85.617L150.741 88.4317L156.633 82.4003C156.764 82.2662 156.916 82.1992 157.088 82.1992C157.26 82.1992 157.403 82.2662 157.517 82.4003L158.426 83.305C158.54 83.4223 158.598 83.573 158.598 83.7573C158.598 83.9416 158.54 84.0924 158.426 84.2097L151.183 91.5982C151.069 91.7322 150.921 91.7992 150.741 91.7992C150.561 91.7992 150.414 91.7322 150.299 91.5982Z'
          fill='#009782'
        />
      </g>
      <rect x='45.2695' y='53' width='23.5692' height='25' fill='white' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M60.1247 29.55C63.2591 29.55 65.796 26.9667 65.796 23.775C65.796 20.5833 63.2591 18 60.1247 18C56.9902 18 54.4533 20.5833 54.4533 23.775C54.4533 26.9667 56.9902 29.55 60.1247 29.55ZM64.0136 31.2H63.5933C62.54 31.7156 61.3703 32.025 60.1247 32.025C58.879 32.025 57.7143 31.7156 56.656 31.2H56.2357C53.0152 31.2 50.4023 33.8606 50.4023 37.14V38.625C50.4023 39.9914 51.491 41.1 52.8329 41.1H67.4164C68.7583 41.1 69.847 39.9914 69.847 38.625V37.14C69.847 33.8606 67.2341 31.2 64.0136 31.2ZM74.7081 29.55C77.3919 29.55 79.5693 27.3328 79.5693 24.6C79.5693 21.8672 77.3919 19.65 74.7081 19.65C72.0244 19.65 69.847 21.8672 69.847 24.6C69.847 27.3328 72.0244 29.55 74.7081 29.55ZM77.1387 31.2H76.9463C76.2424 31.4475 75.4981 31.6125 74.7081 31.6125C73.9182 31.6125 73.1738 31.4475 72.47 31.2H72.2775C71.2445 31.2 70.2926 31.5042 69.4571 31.9941C70.6926 33.3502 71.4673 35.1497 71.4673 37.14V39.12C71.4673 39.2334 71.442 39.3417 71.437 39.45H80.3795C81.7213 39.45 82.81 38.3414 82.81 36.975C82.81 33.7833 80.2731 31.2 77.1387 31.2Z'
        fill='#313D98'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M72 49C72.8333 49 73.5417 49.2917 74.125 49.875C74.7083 50.4583 75 51.1667 75 52V72C75 72.8333 74.7083 73.5417 74.125 74.125C73.5417 74.7083 72.8333 75 72 75H60L61 78H65.5C65.9167 78 66.2708 78.1458 66.5625 78.4375C66.8542 78.7292 67 79.0833 67 79.5C67 79.9167 66.8542 80.2708 66.5625 80.5625C66.2708 80.8542 65.9167 81 65.5 81H48.5C48.0833 81 47.7292 80.8542 47.4375 80.5625C47.1458 80.2708 47 79.9167 47 79.5C47 79.0833 47.1458 78.7292 47.4375 78.4375C47.7292 78.1458 48.0833 78 48.5 78H53L54 75H42C41.1667 75 40.4583 74.7083 39.875 74.125C39.2917 73.5417 39 72.8333 39 72V52C39 51.1667 39.2917 50.4583 39.875 49.875C40.4583 49.2917 41.1667 49 42 49H72ZM70.9999 71V53H43V71H70.9999Z'
        fill='#525252'
      />
    </svg>
  )
}

export const visitSupportIcon = ({ className = '' }) => (
  <svg
    className={className}
    width='224'
    height='100'
    viewBox='0 0 224 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='0.09375' width='223.908' height='100' fill='#F6F8F9' />
    <rect x='95.3516' y='10' width='61.8692' height='80' rx='3' fill='#ECEFF0' />
    <rect x='100.262' y='16' width='52.0487' height='65' fill='#FAFBFB' />
    <path d='M108.608 28.5H143.962' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
    <path d='M108.608 34.5H143.962' stroke='#B3B7D9' strokeWidth='2' strokeLinecap='square' />
    <path
      d='M73.7461 54V75C73.7461 78.866 76.8801 82 80.7461 82H106.028C109.894 82 113.028 78.866 113.028 75V68'
      stroke='#313D98'
      strokeWidth='3'
    />
    <path
      d='M85.5318 26V48.8485C85.5318 52.2459 82.8785 55 79.6056 55H66.9066C63.6337 55 60.9805 52.2459 60.9805 48.8485V26'
      stroke='#B6C0C1'
      strokeWidth='3'
    />
    <ellipse cx='113.03' cy='65' rx='3.9282' ry='4' fill='#9B9B9B' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M173.328 70.55C176.462 70.55 178.999 67.9667 178.999 64.775C178.999 61.5833 176.462 59 173.328 59C170.193 59 167.656 61.5833 167.656 64.775C167.656 67.9667 170.193 70.55 173.328 70.55ZM177.217 72.2H176.796C175.743 72.7156 174.573 73.025 173.328 73.025C172.082 73.025 170.917 72.7156 169.859 72.2H169.439C166.218 72.2 163.605 74.8606 163.605 78.14V79.625C163.605 80.9914 164.694 82.1 166.036 82.1H180.62C181.961 82.1 183.05 80.9914 183.05 79.625V78.14C183.05 74.8606 180.437 72.2 177.217 72.2ZM187.911 70.55C190.595 70.55 192.772 68.3328 192.772 65.6C192.772 62.8672 190.595 60.65 187.911 60.65C185.227 60.65 183.05 62.8672 183.05 65.6C183.05 68.3328 185.227 70.55 187.911 70.55ZM190.342 72.2H190.149C189.446 72.4475 188.701 72.6125 187.911 72.6125C187.121 72.6125 186.377 72.4475 185.673 72.2H185.481C184.448 72.2 183.496 72.5042 182.66 72.9941C183.896 74.3502 184.67 76.1497 184.67 78.14V80.12C184.67 80.2334 184.645 80.3417 184.64 80.45H193.583C194.924 80.45 196.013 79.3414 196.013 77.975C196.013 74.7833 193.476 72.2 190.342 72.2V72.2Z'
      fill='#525252'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M50.9152 84.4508H32.7473V64.1008H34.5641V61.3258C34.5641 60.5549 34.829 59.8997 35.3589 59.3602C35.8888 58.8206 36.5322 58.5508 37.2892 58.5508H46.3732C47.1302 58.5508 47.7737 58.8206 48.3036 59.3602C48.8335 59.8997 49.0984 60.5549 49.0984 61.3258V64.1008H50.9152V84.4508ZM45.4648 62.2508H38.1976V64.1008H45.4648V62.2508ZM56.3656 66.8758V81.6758C56.3656 82.4466 56.1006 83.1018 55.5707 83.6414C55.0408 84.181 54.3974 84.4508 53.6404 84.4508H52.732V64.1008H53.6404C54.3974 64.1008 55.0408 64.3706 55.5707 64.9102C56.1006 65.4497 56.3656 66.1049 56.3656 66.8758ZM30.9305 84.4508H30.0221C29.2651 84.4508 28.6216 84.181 28.0917 83.6414C27.5618 83.1018 27.2969 82.4466 27.2969 81.6758V66.8758C27.2969 66.1049 27.5618 65.4497 28.0917 64.9102C28.6216 64.3706 29.2651 64.1008 30.0221 64.1008H30.9305V84.4508ZM47.2816 74.2758V72.4258C47.2816 72.156 47.1965 71.9344 47.0261 71.7609C46.8558 71.5875 46.6382 71.5008 46.3732 71.5008H43.648V68.7258C43.648 68.456 43.5629 68.2344 43.3925 68.0609C43.2222 67.8875 43.0046 67.8008 42.7396 67.8008H40.9228C40.6579 67.8008 40.4403 67.8875 40.2699 68.0609C40.0996 68.2344 40.0144 68.456 40.0144 68.7258V71.5008H37.2892C37.0243 71.5008 36.8067 71.5875 36.6363 71.7609C36.466 71.9344 36.3808 72.156 36.3808 72.4258V74.2758C36.3808 74.5456 36.466 74.7672 36.6363 74.9406C36.8067 75.1141 37.0243 75.2008 37.2892 75.2008H40.0144V77.9758C40.0144 78.2456 40.0996 78.4672 40.2699 78.6406C40.4403 78.8141 40.6579 78.9008 40.9228 78.9008H42.7396C43.0046 78.9008 43.2222 78.8141 43.3925 78.6406C43.5629 78.4672 43.648 78.2456 43.648 77.9758V75.2008H46.3732C46.6382 75.2008 46.8558 75.1141 47.0261 74.9406C47.1965 74.7672 47.2816 74.5456 47.2816 74.2758Z'
      fill='#313D98'
    />
  </svg>
)

export const consentBuilderIcon = ({ className = '' }) => (
  <svg width='42' height='38' viewBox='0 0 42 38' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.1937 25.397L31.4937 23.097C31.6854 22.9053 31.901 22.8574 32.1406 22.9532C32.3802 23.0491 32.5 23.2407 32.5 23.5282V33.9501C32.5 34.9084 32.1646 35.723 31.4937 36.3938C30.8229 37.0647 30.0083 37.4001 29.05 37.4001H3.74999C2.79165 37.4001 1.97707 37.0647 1.30624 36.3938C0.635405 35.723 0.299988 34.9084 0.299988 33.9501V8.6501C0.299988 7.69176 0.635405 6.87718 1.30624 6.20635C1.97707 5.53551 2.79165 5.2001 3.74999 5.2001H23.4437C23.6833 5.2001 23.851 5.31989 23.9469 5.55947C24.0427 5.79906 23.9948 6.01468 23.8031 6.20635L21.5031 8.50635C21.4073 8.60218 21.2875 8.6501 21.1437 8.6501H3.74999V33.9501H29.05V25.7563C29.05 25.6126 29.0979 25.4928 29.1937 25.397ZM40.4781 10.8782L21.575 29.7813L15.1062 30.5001C14.1479 30.5959 13.3333 30.3084 12.6625 29.6376C11.9917 28.9668 11.7042 28.1522 11.8 27.1938L12.5187 20.7251L31.4219 1.82197C32.2364 1.00739 33.2307 0.600098 34.4047 0.600098C35.5786 0.600098 36.5729 1.00739 37.3875 1.82197L40.4781 4.9126C41.2927 5.72718 41.7 6.72145 41.7 7.89541C41.7 9.06937 41.2927 10.0636 40.4781 10.8782ZM33.3625 13.1063L29.1937 8.9376L15.825 22.3063L15.3219 26.9782L19.9937 26.4751L33.3625 13.1063ZM38.0344 7.35635L34.9437 4.26572C34.8 4.12197 34.6203 4.0501 34.4047 4.0501C34.189 4.0501 34.0094 4.12197 33.8656 4.26572L31.6375 6.49385L35.8062 10.6626L38.0344 8.43447C38.1781 8.29072 38.25 8.11103 38.25 7.89541C38.25 7.67979 38.1781 7.5001 38.0344 7.35635Z'
      fill='#313D98'
    />
  </svg>
)

export const pdfUploadIcon = ({ className = '' }) => (
  <svg width='46' height='34' viewBox='0 0 46 34' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M46 23.8999C46 25.577 45.5927 27.1223 44.7781 28.5358C43.9635 29.9494 42.8495 31.0634 41.4359 31.878C40.0224 32.6926 38.4771 33.0999 36.8 33.0999H10.35C8.48125 33.0999 6.75625 32.6327 5.175 31.6983C3.59375 30.764 2.33594 29.5062 1.40156 27.9249C0.467187 26.3437 0 24.6187 0 22.7499C0 20.5457 0.646875 18.5452 1.94062 16.7483C3.23438 14.9515 4.8875 13.6937 6.9 12.9749V12.3999C6.9 10.3395 7.4151 8.42282 8.44531 6.6499C9.47552 4.87699 10.8771 3.47542 12.65 2.44521C14.4229 1.41501 16.3516 0.899902 18.4359 0.899902C20.5203 0.899902 22.449 1.42699 24.2219 2.48115C25.9948 3.53532 27.3844 4.9249 28.3906 6.6499C29.5406 5.88323 30.8104 5.4999 32.2 5.4999C34.1167 5.4999 35.7458 6.17074 37.0875 7.5124C38.4292 8.85407 39.1 10.4832 39.1 12.3999C39.1 13.2624 38.9562 14.1009 38.6688 14.9155C40.7771 15.3468 42.526 16.4009 43.9156 18.078C45.3052 19.7551 46 21.6957 46 23.8999ZM29.1093 17.3593L21.4906 9.74053C21.2989 9.54886 21.0354 9.45303 20.7 9.45303C20.3645 9.45303 20.101 9.54886 19.9093 9.74053L12.2906 17.3593C11.9552 17.6947 11.8833 18.102 12.075 18.5812C12.2666 19.0603 12.626 19.2999 13.1531 19.2999H17.825V27.3499C17.825 27.6853 17.9328 27.9608 18.1484 28.1765C18.364 28.3921 18.6395 28.4999 18.975 28.4999H22.4249C22.7604 28.4999 23.0359 28.3921 23.2515 28.1765C23.4671 27.9608 23.5749 27.6853 23.5749 27.3499V19.2999H28.2468C28.7739 19.2999 29.1333 19.0603 29.3249 18.5812C29.5166 18.102 29.4447 17.6947 29.1093 17.3593Z'
      fill='#313D98'
    />
  </svg>
)

export const carouselModeIcon = () => (
  <svg width='66' height='66' viewBox='0 0 66 66' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='33' cy='33' r='31' fill='#ffffff' stroke='#979797' strokeWidth='4' />
    <g mask='url(#mask0_2660_4690)'>
      <path
        opacity='0.733761'
        d='M53 24C53 22.8954 53.8954 22 55 22H63C64.1046 22 65 22.8954 65 24V42C65 43.1046 64.1046 44 63 44H55C53.8954 44 53 43.1046 53 42V24Z'
        fill='#979797'
      />
      <g filter='url(#filter0_d_2660_4690)'>
        <path
          d='M17 18C17 15.7909 18.7909 14 21 14H45C47.2091 14 49 15.7909 49 18V48C49 50.2091 47.2091 52 45 52H21C18.7909 52 17 50.2091 17 48V18Z'
          fill='#979797'
        />
      </g>
      <path
        opacity='0.733761'
        d='M1 24C1 22.8954 1.89543 22 3 22H11C12.1046 22 13 22.8954 13 24V42C13 43.1046 12.1046 44 11 44H3C1.89543 44 1 43.1046 1 42V24Z'
        fill='#979797'
      />
    </g>
  </svg>
)

export const calendarModeIcon = () => (
  <svg width='66' height='66' viewBox='0 0 66 66' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter0_b_2670_7669)'>
      <circle cx='33' cy='33' r='31' fill='#F9F9FF' stroke='#979797' strokeWidth='4' />
      <g mask='url(#mask0_2670_7669)'></g>
    </g>
    <g filter='url(#filter1_b_2670_7669)'>
      <rect x='22.7197' y='20' width='2.08' height='6.5' rx='0.5' fill='#D8D8D8' stroke='#979797' />
      <rect x='41.1992' y='20' width='2.08' height='6.5' rx='0.5' fill='#D8D8D8' stroke='#979797' />
      <path
        d='M17.5996 25.5C17.5996 23.8431 18.9428 22.5 20.5996 22.5H45.3996C47.0565 22.5 48.3996 23.8431 48.3996 25.5V30H17.5996V25.5Z'
        fill='#979797'
      />
      <rect x='18.5996' y='23.5' width='28.8' height='22' rx='2' stroke='#979797' strokeWidth='2' />
    </g>
  </svg>
)

export const icons = {
  audit: auditReportIcon(),
  auditInsights: auditReportIcon(),
  externalLink: externalLinkIcon(),
  exclamation: exclamationIcon(),
  cases: casesIcon(),
  communication: communicationIcon(),
  dataInbox: communicationIcon(),
  compliance: complianceIcon(),
  configuration: settingsIcon(),
  maintenanceTool: settingsIcon(),
  consents: consentsIcon(),
  geofenceEvents: geofenceEventIcon(),
  geofences: geofencesIcon(),
  home: homeIcon(),
  insights: complianceIcon(),
  instruments: instrumentsIcon(),
  logo: dchLogo(),
  logout: logout(),
  myProfile: myProfileIcon(),
  notifications: systemNotyIcon(),
  participants: participantsIcon(),
  payments: paymentsIcon(),
  sites: sitesIcon(),
  studies: studiesIcon(),
  users: usersIcon(),
  virtualvisits: virtualVisitIcon(),
  sidebarNotification: sidebarNotificationIcon,
}
